import React, { useEffect } from "react";

const PolitiqueConfidentialite: React.FC = () => {
  const title = "Politique de confidentialité | Mon Copieur";
  const description = "Politique de confidentialité de Mon Copieur.";

  useEffect(() => {
    document.title = title;
    let metaTag = document.querySelector('meta[name="description"]') as HTMLMetaElement | null;
    if (!metaTag) {
      metaTag = document.createElement("meta");
      metaTag.name = "description";
      document.head.appendChild(metaTag);
    }
    metaTag.content = description;
  }, []);

  return (
    <>
      <header className="border-b border-border bg-secondary/40">
        <div className="container mx-auto px-4 py-10">
          <h1 className="text-3xl font-semibold">Politique de confidentialité</h1>
        </div>
      </header>

      <article className="prose prose-neutral max-w-none container mx-auto px-4 py-8">
        <section>
          <h2>1. Collecte des informations</h2>
          <p>
            Nous recueillons des informations lorsque vous vous inscrivez sur notre site, lorsque vous
            vous connectez à votre compte, faites un achat, participez à un concours, et/ou lorsque vous
            vous déconnectez. Les informations recueillies incluent votre nom, votre adresse électronique,
            numéro de téléphone, et/ou carte de crédit.
          </p>
          <p>
            En outre, nous recevons et enregistrons automatiquement des informations à partir de votre
            ordinateur et navigateur, y compris votre adresse IP, vos logiciels et matériels, et la page
            que vous demandez.
          </p>
        </section>

        <section>
          <h2>2. Utilisation des informations</h2>
          <p>
            Toutes les informations que nous recueillons auprès de vous peuvent être utilisées pour :
          </p>
          <ul>
            <li>Personnaliser votre expérience et répondre à vos besoins individuels</li>
            <li>Fournir un contenu publicitaire personnalisé</li>
            <li>Améliorer notre site Web</li>
            <li>Améliorer le service client et vos besoins de prise en charge</li>
            <li>Vous contacter par e-mail</li>
            <li>Administrer un concours, une promotion, ou une enquête</li>
          </ul>
        </section>

        <section>
          <h2>3. Confidentialité du commerce électronique</h2>
          <p>
            Nous sommes les seuls propriétaires des informations recueillies sur ce site. Vos
            informations personnelles ne seront pas vendues, échangées, transférées, ou données à une
            autre société pour n'importe quelle raison, sans votre consentement, en dehors de ce qui est
            nécessaire pour répondre à une demande et/ou une transaction, comme par exemple expédier
            une commande.
          </p>
        </section>

        <section>
          <h2>4. Divulgation à des tiers</h2>
          <p>
            Nous ne vendons, n'échangeons et ne transférons pas vos informations personnelles
            identifiables à des tiers. Cela ne comprend pas les tierce parties de confiance qui nous
            aident à exploiter notre site Web ou à mener nos affaires, tant que ces parties conviennent
            de garder ces informations confidentielles.
          </p>
          <p>
            Nous pensons qu'il est nécessaire de partager des informations afin d'enquêter, de prévenir
            ou de prendre des mesures concernant des activités illégales, fraudes présumées, situations
            impliquant des menaces potentielles à la sécurité physique de toute personne, violations de
            nos conditions d'utilisation, ou quand la loi nous y oblige.
          </p>
          <p>
            Les informations non-privées, cependant, peuvent être fournies à d'autres parties pour le
            marketing, la publicité, ou d'autres utilisations.
          </p>
        </section>

        <section>
          <h2>5. Protection des informations</h2>
          <p>
            Nous mettons en œuvre une variété de mesures de sécurité pour préserver la sécurité de vos
            informations personnelles. Nous utilisons un cryptage à la pointe de la technologie pour
            protéger les informations sensibles transmises en ligne. Nous protégeons également vos
            informations hors ligne. Seuls les employés qui ont besoin d'effectuer un travail spécifique
            (par exemple, la facturation ou le service à la clientèle) ont accès aux informations
            personnelles identifiables. Les ordinateurs et serveurs utilisés pour stocker des
            informations personnelles identifiables sont conservés dans un environnement sécurisé.
          </p>
        </section>

        <section>
          <h2>6. Est-ce que nous utilisons des cookies ?</h2>
          <p>
            Oui. Nos cookies améliorent l'accès à notre site et identifient les visiteurs réguliers. En
            outre, nos cookies améliorent l'expérience d'utilisateur grâce au suivi et au ciblage de
            leurs intérêts. Cependant, cette utilisation des cookies n'est en aucune façon liée à des
            informations personnelles identifiables sur notre site.
          </p>
        </section>

        <section>
          <h2>7. Se désabonner</h2>
          <p>
            Nous utilisons l'adresse e-mail que vous fournissez pour vous envoyer des informations et
            des mises à jour relatives à votre commande, des nouvelles de l'entreprise de façon
            occasionnelle, des informations sur des produits liés, etc. Si à tout moment vous souhaitez
            vous désinscrire de recevoir des e-mails, nous avons inclus des instructions détaillées de
            désabonnement au bas de chaque e-mail.
          </p>
        </section>

        <section>
          <h2>8. Consentement</h2>
          <p>
            En utilisant notre site, vous consentez à notre politique de confidentialité.
          </p>
        </section>
      </article>
    </>
  );
};

export default PolitiqueConfidentialite;